import {Component, Input, OnInit} from '@angular/core';
import {ApiService} from '../../../service/api.service';
import {ActivatedRoute} from '@angular/router';
import {WelfareProject} from '../../../class/welfare-project';

@Component({
  selector: 'app-report-printer',
  templateUrl: './report-printer.component.html',
  styleUrls: ['./report-printer.component.css']
})
export class ReportPrinterComponent implements OnInit {

  @Input()
  project: WelfareProject;

  constructor(private api: ApiService, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const projectID = params.id;
      if (projectID) {
        this.api.loadProjectByID(projectID, 'welfy').subscribe(value => {
          this.project = value;
        });
      }
    });
  }

  get result() {
    if (this.project) {
      return this.project.welfareProjectResult;
    }
    return null;
  }

  print() {
    window.print();
  }
}
